import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store, allMessage, lang) => {
        return seo({
            title: lang === "hu" ? "Felhasználási feltételek" : "Terms of usage",
            allMessage,
            lang,
            type: "article",
        });
    },
};
